import * as React from 'react'

import { useSelectContext } from './context'
import { OptionData, OptionApi } from './types'

export function useOption(option: OptionData): OptionApi {
    const { deregister, register, navigableRegister } = useSelectContext()

    React.useEffect(() => {
        register(option)

        return () => {
            deregister(option)
        }
    }, [option.disabled, register, deregister])

    return navigableRegister(option)
}
